import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const DebugAuth = () => {
  const { currentUser, isAdmin, loading } = useAuth();
  
  console.log('DebugAuth - currentUser:', currentUser);
  console.log('DebugAuth - isAdmin:', typeof isAdmin === 'function' ? isAdmin() : 'not a function');
  console.log('DebugAuth - loading:', loading);
  
  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Debug Authentication</h1>
      
      <div className="bg-white p-4 rounded-lg shadow mb-4">
        <h2 className="text-lg font-semibold mb-2">Loading State</h2>
        <p>Loading: {loading ? 'true' : 'false'}</p>
      </div>
      
      <div className="bg-white p-4 rounded-lg shadow mb-4">
        <h2 className="text-lg font-semibold mb-2">Current User</h2>
        <p>User exists: {currentUser ? 'true' : 'false'}</p>
        {currentUser && (
          <div className="mt-2">
            <p>Email: {String(currentUser.email || 'N/A')}</p>
            <p>Username: {String(currentUser.username || 'N/A')}</p>
            <p>Role: {String(currentUser.role || 'N/A')}</p>
            <p>ID: {String(currentUser._id || 'N/A')}</p>
          </div>
        )}
      </div>
      
      <div className="bg-white p-4 rounded-lg shadow mb-4">
        <h2 className="text-lg font-semibold mb-2">Admin Check</h2>
        <p>isAdmin function: {typeof isAdmin === 'function' ? 'OK' : 'ERROR'}</p>
        {typeof isAdmin === 'function' && (
          <p>Is Admin: {isAdmin() ? 'true' : 'false'}</p>
        )}
      </div>
      
      <div className="bg-white p-4 rounded-lg shadow">
        <h2 className="text-lg font-semibold mb-2">Raw Data (JSON)</h2>
        <pre className="text-sm bg-gray-100 p-2 rounded overflow-auto">
          {currentUser ? JSON.stringify(currentUser, null, 2) : 'No user data'}
        </pre>
      </div>
    </div>
  );
};

export default DebugAuth;
